import { z } from "zod"

export const AttachmentLinkFormDataSchema = z.record(
  z.string(),
  z.boolean().or(z.undefined())
)

export type AttachmentLinkFormData = z.infer<
  typeof AttachmentLinkFormDataSchema
>
